import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center vh-100" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-1 fw-bold" }, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fs-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Opps!"),
  /*#__PURE__*/_createTextVNode(" Page not found.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " The page you’re looking for doesn’t exist. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "btn btn-primary"
}, "Go Home", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("p", null, " Route parameters " + _toDisplayString(_ctx.$route.params), 1),
      _hoisted_6
    ])
  ]))
}